<template>
  <div>
    <modalWindow v-if="manage !== null" @close="clearMessage" width="600">
      <div class="titlebar">Beheer kosten {{ find(assets, { 'id': manage }).name }}</div>
      <span v-if="msg.msg" :class="['form-' + msg.type]">{{ msg.msg }}</span>
      <form @submit.prevent class="inset">
        <input
          type="text"
          v-model="friendlyName"
          ref="friendly_name"
          placeholder="friendly name"
        >
        <textarea
          rows="8"
          v-model="description"
          placeholder="Omschrijving"
        />
        <input
          type="text"
          v-model="sustainabilityScore"
          placeholder="Duurzaamheidsscore"
        >
        <input
          type="text"
          v-model="link"
          placeholder="Link"
        >
        <input type="submit" @click="updateAsset" value="Details toevoegen">
      </form>
      <div style="margin-left: 10px; margin-right: 10px;">
        <table class="new">
          <thead class="table-legend">
            <tr>
              <th>Datum</th>
              <th>Eenmalig</th>
              <th>Transacties</th>
              <th>Incidenteel</th>
              <th>TER</th>
              <th>Spread</th>
            </tr>
          </thead>
          <tr v-for="cost in costs" :key="cost.date" @click="removeCost(cost.date)">
            <td width=50>{{(new Date(cost.date)).toLocaleDateString('nl-nl')}}</td>
            <td>{{cost.onetime}}</td>
            <td>{{cost.transaction}}</td>
            <td>{{cost.incidental}}</td>
            <td>{{cost.expenses}}</td>
            <td>{{cost.spread}}</td>
          </tr>
        </table>
      </div>
      <form @submit.prevent class="inset">
        <input type="date" ref="date" placeholder="Datum" value="2017-01-01">
        <input type="number" step="any" ref="onetime" placeholder="Eenmalige kosten">
        <input type="number" step="any" ref="transaction" placeholder="Transactie kosten">
        <input type="number" step="any" ref="incidental" placeholder="Incidentele kosten">
        <input type="number" step="any" ref="expenses" placeholder="TER kosten">
        <input type="number" step="any" ref="spread" placeholder="Spread">
        <input type="submit" @click="createCost" value="Kosten toevoegen">
      </form>
    </modalWindow>

    <div class="row menubar">
      <input
        type=text ref="search" placeholder="Zoeken"
        @keyup="updateSearch" class="searchbar"
      >
      <multiDropdown
        v-model="selectedTypes"
        :array="types"
        displayPrefix="Soort"
        style="float:right"
        :cb="dropdownCB"
      />
      <multiDropdown
        v-model="selectedBanks"
        :array="banks"
        displayPrefix="Bank"
        style="float:right"
        :cb="dropdownCB"
      />
      <multiDropdown
        v-model="selectedSectors"
        :array="sectors"
        displayPrefix="Sector"
        style="float:right"
        :cb="dropdownCB"
      />
      <multiDropdown
        v-model="selectedClasses"
        :array="classes"
        displayPrefix="Type"
        style="float:right"
        :cb="dropdownCB"
      />
    </div>
    <div class="card" v-if="assets.length > 0">
      <table width=100%>
        <thead class="table-legend">
          <tr>
            <th>#</th>
            <th>Instrument</th>
            <th>Type</th>
            <th>Sector</th>
            <th>Banken</th>
            <th></th>
          </tr>
        </thead>
        <tr
          v-for="asset in slice(
            filteredAssets,
            currentPage * resultsPerPage,
            (currentPage + 1) * resultsPerPage
          )"
          :key="asset.id"
        >
          <td width=50>{{ asset.id }}</td>
          <td>
            {{ asset.name }}
              <awesomeIcon
                 v-if="asset.costs > 0" style="float: right"
                class="green" icon="money-check"
              />
          </td>
          <td>{{ asset.class }} ({{ types[asset.type].label }})</td>
          <td>{{ asset.sector }}</td>
          <td>{{ asset.banks }}</td>
          <td>
            <button class="secondary" @click="manage=asset.id">
              <awesomeIcon icon="cog" /> Aanpassen
            </button>
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="filteredAssets.length"
        :resultsPerPage="resultsPerPage"
      />
    </div>
    <div v-else class="loader" />
  </div>
</template>

<script>
import {
  filter,
  find,
  includes,
  slice,
} from 'lodash-es';

export default {
  name: 'AdminAssets',
  data() {
    return {
      friendlyName: null,
      description: null,
      sustainabilityScore: null,
      link: null,
      search: '',
      assets: [],
      currentPage: 0,
      resultsPerPage: 20,
      manage: null,
      costs: [],
      msg: { msg: null, type: 'notice' },
      selectedBanks: '',
      banks: [],
      selectedSectors: '',
      sectors: [],
      selectedClasses: '',
      classes: [],
      selectedTypes: '',
      types: [
        { label: 'Standaard', value: 0 },
        { label: 'ETF', value: 1 },
        { label: 'BM', value: 2 },
      ],
    };
  },
  watch: {
    manage(asset) {
      this.costs = [];
      if (asset !== null) {
        this.updateCosts();
        this.getAsset();
      }
    },
  },
  created() {
    this.getAssets();
  },
  computed: {
    filteredAssets() {
      // Creating bank filter
      let arrayBanks = [];
      if (this.selectedBanks) {
        arrayBanks = this.selectedBanks.split(',');
      }
      let bankFilter = [...arrayBanks]; // Create clone to not change selectedBrands
      if (!Array.isArray(bankFilter)) {
        bankFilter = [];
      }
      if (bankFilter.length === 0) {
        for (let i = 0; i < this.banks.length; i += 1) {
          bankFilter.push(this.banks[i].value);
        }
      }
      // Creating sector filter
      let arraySectors = [];
      if (this.selectedSectors) {
        arraySectors = this.selectedSectors.split(',');
      }
      let sectorFilter = [...arraySectors]; // Create clone to not change selectedSectors
      if (!Array.isArray(sectorFilter)) {
        sectorFilter = [];
      }
      if (sectorFilter.length === 0) {
        for (let i = 0; i < this.sectors.length; i += 1) {
          sectorFilter.push(this.sectors[i].value);
        }
      }
      // Creating class filter
      let arrayClasses = [];
      if (this.selectedClasses) {
        arrayClasses = this.selectedClasses.split(',');
      }
      let classFilter = [...arrayClasses]; // Create clone to not change selectedClasses
      if (!Array.isArray(classFilter)) {
        classFilter = [];
      }
      if (classFilter.length === 0) {
        for (let i = 0; i < this.classes.length; i += 1) {
          classFilter.push(this.classes[i].value);
        }
      }
      // creating type filter
      let arrayTypes = [];
      if (this.selectedTypes) {
        arrayTypes = this.selectedTypes.split(',').map(Number);
      }
      let typeFilter = [...arrayTypes]; // Create clone to not change selectedTypes
      if (!Array.isArray(typeFilter)) {
        typeFilter = [];
      }
      if (typeFilter.length === 0) {
        for (let i = 0; i < this.types.length; i += 1) {
          typeFilter.push(this.types[i].value);
        }
      }
      return filter(
        filter(
          filter(
            filter(
              filter(this.assets, this.searchFilter),
              (obj) => includes(classFilter, obj.class),
            ),
            (obj) => includes(typeFilter, obj.type),
          ),
          (obj) => includes(sectorFilter, obj.sector),
        ),
        (obj) => bankFilter.some((v) => obj.banks.split(' ').includes(v)),
      );
    },
  },
  methods: {
    filter,
    slice,
    find,
    dropdownCB() {
      this.currentPage = 0;
    },
    searchFilter(obj) {
      const trimmedSearch = this.search.trim();
      if (obj.name.toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (obj.id.toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (obj.sector !== null && obj.sector.toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (obj.class !== null && obj.class.toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      return false;
    },
    removeCost(date) {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u deze kosten regel wilt verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.removeAssetCost(
              this.manage,
              `${(new Date(date)).getFullYear()}-${(new Date(date)).getMonth() + 1}-${(new Date(date)).getDate()}`,
              this.updateCosts,
            );
          }
        },
      });
    },
    updateCosts() {
      this.sdk.getAssetCosts(this.manage, (response) => {
        if (response.status === 200) {
          this.costs = response.data;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
    getAsset() {
      this.sdk.getAsset(this.manage, (response) => {
        if (response.status === 200 && response.data[0]) {
          this.friendlyName = response.data[0].friendly_name;
          this.description = response.data[0].description;
          this.sustainabilityScore = response.data[0].sustainable_score;
          this.link = response.data[0].link;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
    createCost() {
      this.sdk.createAssetCost(
        this.manage,
        this.$refs.date.value,
        this.$refs.transaction.value,
        this.$refs.onetime.value,
        this.$refs.incidental.value,
        this.$refs.expenses.value,
        this.$refs.spread.value,
        (response) => {
          if (response.status === 200) {
            this.updateCosts();
          }
        },
      );
    },
    updateAsset() {
      this.sdk.updateAsset(
        this.manage,
        this.friendlyName,
        this.description,
        this.sustainabilityScore,
        this.link,
        (response) => {
          if (response.status === 200) {
            this.getAsset();
          }
        },
      );
    },
    clearMessage() {
      this.manage = null;
      this.msg = { msg: null, type: 'notice' };
    },
    updateSearch() {
      this.currentPage = 0;
      this.search = this.$refs.search.value.toLowerCase();
    },
    getAssets() {
      this.sdk.getAssets((response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i += 1) {
            if (!response.data[i].sector) {
              response.data[i].sector = 'Geen';
            }
            // store list of banks
            const spl = response.data[i].banks.split(' ');
            for (let j = 0; j < spl.length; j += 1) {
              if (this.banks.map((v) => v.value).indexOf(spl[j]) === -1) {
                this.banks.push({ label: spl[j], value: spl[j] });
              }
            }
            // Store list of sectors
            if (this.sectors.map((v) => v.value).indexOf(response.data[i].sector) === -1) {
              this.sectors.push({ label: response.data[i].sector, value: response.data[i].sector });
            }
            // Store list of classes
            if (this.classes.map((v) => v.value).indexOf(response.data[i].class) === -1) {
              this.classes.push({ label: response.data[i].class, value: response.data[i].class });
            }
          }
          this.assets = response.data;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .secondary {
    padding: 0 10px;
    float: right;
  }
</style>
